export type ClassNameValue = string | false | null | undefined;

export function joinClassNames(
  ...classNames: ClassNameValue[]
): string | undefined {
  const value = classNames.filter(Boolean).join(' ');
  return value || undefined;
}
